import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_TICKET_DETAILS, UPDATE_TICKET_DETAILS_SUCCESS, UPDATE_TICKET_DETAILS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* updateTicketDetails({ payload }) {
  const { ticketId } = payload;
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/${ticketId}/details`,
      method: 'PATCH',
      data: payload.data,
      isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: UPDATE_TICKET_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_TICKET_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_TICKET_DETAILS_ERROR, payload: error });
  }
}

export function* watchUpdateTicketDetails() {
  yield takeEvery(UPDATE_TICKET_DETAILS, updateTicketDetails);
}

function* updateTicketDetailsSaga() {
  yield all([fork(watchUpdateTicketDetails)]);
}

export default updateTicketDetailsSaga;
